import { safetyTips } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function SafetyTips() {
  return (
    <section id="safety" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="安全提醒"
          title="找入口的同时，也要保护好自己"
          desc="越是在「打不开」的时候，越容易点进仿冒站点。记住下面几点，能帮你避开大部分风险。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {safetyTips.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-accent-200 bg-accent-50 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}